<template>
  <div
    v-on="
      openOn === 'click'
        ? { click: toggleMenu }
        : dontHide
        ? {}
        : { mouseenter: toggleMenu, mouseleave: toggleMenu }
    "
    class="link-menu__wrapper"
  >
    <ul
      class="link-menu__contents"
      ref="linkMenu"
      :class="{ ['is-active']: isOpen }"
      v-if="isOpen"
    >
      <VTooltip
        v-for="(link, idx) in data"
        :key="idx"
        :text="link.tooltip"
        :position="link.tooltipPosition"
        extraClass="vlink-menu-tooltip"
      >
        <li
          :class="{ [link.extraClass]: true, [link.key]: true }"
          @click="
            e => {
              getClickHandler(e, link);
            }
          "
          :set="(iconClass = getIconClass(link.key))"
        >
          <a
            v-if="getLinkType(link) === 'href'"
            :href="link.href"
            :key="link.key"
          >
            <img
              v-if="iconClass === 'image'"
              :src="getImage(link.key)"
              :class="{ [link.key]: true }"
            />
            <i v-else-if="iconClass" :class="iconClass" :title="link.name"></i>

            <span v-else>{{ link.name }}</span>
          </a>
          <a v-else :key="link.key" :title="link.name">
            <img
              v-if="iconClass === 'image'"
              :src="getImage(link.key)"
              :class="link.key"
            />
            <i :class="iconClass" v-else-if="iconClass" :title="link.name"></i>
            <span v-else>{{ link.name }}</span>
          </a>
        </li>
      </VTooltip>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import withNavigate from "@/mixins/withNavigate";
import hubspotIcon from "@/assets/images/hubspot.svg";
import dripIcon from "@/assets/images/drip.svg";
import VTooltip from "@/components/VTooltip";

export default Vue.component("VLinkMenu", {
  data() {
    return {
      isOpen: this.dontHide,
      iconMap: {
        view: "fa fa-eye",
        edit: "fa fa-edit",
        hubspot: "image",
        drip: "image",
        copy: "far fa-copy",
        delete: "far fa-trash"
      },
      imageMap: {
        hubspot: hubspotIcon,
        drip: dripIcon
      }
    };
  },
  props: {
    data: VueTypes.array.isRequired,
    openOn: VueTypes.oneOf(["hover", "click"]).def("click"),
    dontHide: VueTypes.bool.def(false)
  },
  components: {
    VTooltip
  },
  mixins: [withNavigate],
  methods: {
    getLinkType(link) {
      if (link.onClick) {
        return "onClick";
      } else if (link.href) {
        return "href";
      } else if (link.routerLink) {
        return "routerLink";
      } else {
        return "unknown";
      }
    },

    getIconClass(name) {
      return this.iconMap[name.toLowerCase()];
    },

    getImage(name) {
      return this.imageMap[name.toLowerCase()];
    },

    toggleMenu(e) {
      this.isOpen = !this.isOpen;
      e.stopPropagation();
    },

    closeMenu() {
      this.isOpen = false;
    },

    getClickHandler(e, link) {
      const linkType = this.getLinkType(link);

      switch (linkType) {
        case "routerLink":
          return this.navigate(link.routerLink);

        case "onClick":
          return link.onClick(e);

        default:
          return null;
      }
    },

    documentClick(e) {
      if (this.dontHide) {
        return;
      }

      const linkMenuEl = this.$refs.linkMenu;

      if (!linkMenuEl) {
        return;
      }

      const target = e.target;

      if (linkMenuEl !== target && !linkMenuEl.contains(target)) {
        this.isOpen = false;
      }
    }
  },
  created() {
    document.addEventListener("click", this.documentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.documentClick);
  }
});
</script>

<style lang="scss" scoped>
$ns: "link-menu";

.#{$ns}__wrapper {
  cursor: pointer;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0;
  z-index: 1;

  .#{$ns}__contents {
    justify-content: center;
    align-items: center;
    margin: 0;
    height: 100%;
    border-radius: 4px;
    text-align: left;
    display: none;
    pointer-events: none;
    top: 0;
    right: 0;
    z-index: 999;
    position: relative;
    box-shadow: none;
    background: transparent;
    min-width: auto;

    &.is-active {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      pointer-events: all;
    }

    &--left {
      right: auto;
      left: 0;
    }

    li {
      display: flex;
      list-style: none;
      height: 100%;
      border-radius: 0;
      transition: background 0.15s linear;
      padding: 0;
      width: 35px;
      min-width: 35px;
      justify-content: flex-start;

      &:first-child {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }

      &:last-child {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        font-size: 14px;

        i {
          font-size: 18px;
          transition: color 0.15s linear;
          color: #c6ccd8;
        }

        img {
          width: 24px;
        }
      }

      &:hover {
        background: transparent;
        i {
          color: $primary-color;
        }

        &.delete {
          i {
            color: $danger-color;
          }
        }
      }
    }
  }
}

.#{$ns}contents-mobile {
  display: block;

  @media (min-width: 767px) {
    display: none;
  }
}
</style>

<style lang="scss">
.vlink-menu-tooltip {
  [tooltip][flow^="up"]::after {
    @include textCropEllipsis();
    margin-right: 10px;
  }
}
</style>
